// src/utils/logService.js
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  limit,
  doc,
  getDoc,
} from "firebase/firestore";

export const logService = {
  // Create a new log entry
  async createLog(action, details = {}, user = null) {
    try {
      let createdByName = "Unknown User";

      if (user?.uid) {
        // First try to get displayName from auth user
        if (user.displayName) {
          createdByName = user.displayName;
        } else if (user.email) {
          // If no displayName, try to get it from user document in Firestore
          try {
            const userDoc = await getDoc(doc(db, "users", user.uid));
            if (userDoc.exists()) {
              const userData = userDoc.data();
              createdByName = userData.displayName || user.email;
            } else {
              createdByName = user.email;
            }
          } catch (firestoreError) {
            console.warn("Could not fetch user document:", firestoreError);
            createdByName = user.email || "Unknown User";
          }
        }
      }

      const logData = {
        action,
        details,
        created_by_name: createdByName,
        created_by_id: user?.uid || "unknown",
        timestamp: new Date(),
        createdAt: new Date().toISOString(),
      };

      await addDoc(collection(db, "logs"), logData);
      console.log(`Log created: ${action} by ${logData.created_by_name}`);
    } catch (error) {
      console.error("Error creating log:", error);
    }
  },

  // Get all logs
  async getAllLogs(limitCount = 100) {
    try {
      const q = query(
        collection(db, "logs"),
        orderBy("timestamp", "desc"),
        limit(limitCount)
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    } catch (error) {
      console.error("Error fetching logs:", error);
      return [];
    }
  },

  // Log actions
  actions: {
    AGENT_CREATED: "Agent Created",
    AGENT_STATUS_CHANGED: "Agent Status Changed",
    VALIDATION_ADDED: "Validation Added",
    USER_LOGGED_IN: "User Logged In",
    USER_REGISTERED: "User Registered",
    USER_ADDED_BY_ADMIN: "User Added by Admin",
  },
};
